import { render } from "./TaskColumn.vue?vue&type=template&id=19637999&scoped=true"
import script from "./TaskColumn.vue?vue&type=script&lang=js"
export * from "./TaskColumn.vue?vue&type=script&lang=js"

import "./TaskColumn.vue?vue&type=style&index=0&id=19637999&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19637999"]])

export default __exports__